// src/pages/CGUPage.jsx
import React from 'react';
import LegalLayout from '../components/LegalLayout';
import Seo from '../components/Seo';

const CGUPage = () => {
  const articles = [
    {
      title: '1. Acceptation des CGU',
      content: `
        <p>L'utilisation de YAQAM implique l'acceptation pleine et entière des présentes Conditions Générales d'Utilisation (ci-après "CGU").</p>
      `
    },
    {
      title: '2. Accès au service',
      content: `
        <p>L'accès au service nécessite la création d'un compte personnel. L'Utilisateur s'engage à fournir des informations exactes, complètes et à jour lors de l'inscription.</p>
      `
    },
    {
      title: '3. Obligations de l\'Utilisateur',
      content: `
        <p>L'Utilisateur s'engage à utiliser le service conformément aux présentes CGU et à la législation en vigueur. Il s'interdit notamment :</p>
        <ul class="list-disc pl-5 space-y-1 mt-2">
          <li>Toute utilisation frauduleuse ou abusive du service</li>
          <li>Toute activité susceptible de perturber ou d'entraver le bon fonctionnement du service</li>
        </ul>
      `
    },
    {
      title: '4. Responsabilité',
      content: `
        <p>"Y A Quoi à Manger" ne pourra être tenue responsable des dommages indirects résultant de l'utilisation du service, notamment en cas d'indisponibilité temporaire, de problèmes techniques, ou d'informations erronées fournies par les partenaires tiers.</p>
      `
    },
    {
      title: '5. Propriété intellectuelle',
      content: `
        <p>Tous les contenus présents sur "Y A Quoi à Manger", incluant mais non limité aux textes, images, recettes et logos, sont protégés par la propriété intellectuelle et restent la propriété exclusive de "Y A Quoi à Manger" ou de ses partenaires. Toute reproduction ou utilisation non autorisée est interdite.</p>
      `
    },
    {
      title: '6. Modification des CGU',
      content: `
        <p>"Y A Quoi à Manger" se réserve le droit de modifier les présentes CGU à tout moment. Les modifications entreront en vigueur dès leur mise en ligne. L'Utilisateur sera informé des modifications lors de sa connexion au service.</p>
      `
    },
    {
      title: '7. Loi applicable et juridiction compétente',
      content: `
        <p>Les présentes CGU sont soumises au droit français. En cas de litige relatif à l'interprétation ou à l'exécution des présentes CGU, les parties privilégieront une solution amiable.</p>
        <p class="mt-2">À défaut d'accord amiable, les tribunaux compétents du ressort de la Cour d'appel de [ville] seront saisis, sous réserve des dispositions légales impératives contraires.</p>
      `
    }
  ];

  return (
    <>
      <Seo
        title="Conditions Générales d'Utilisation"
        description="Consultez les conditions générales d'utilisation du service YAQAM."
        noindex
        breadcrumb
      />
      <LegalLayout title="Conditions Générales d'Utilisation (CGU)">
      <div className="space-y-8">
        {articles.map((article, index) => (
          <div key={index} className="border-b border-gray-100 pb-6 last:border-0 last:pb-0">
            <h2 className="text-xl font-semibold mb-4" style={{ color: '#2C3E50' }}>{article.title}</h2>
            <div 
              className="text-gray-700"
              dangerouslySetInnerHTML={{ __html: article.content }}
            />
          </div>
        ))}
      </div>
      </LegalLayout>
    </>
  );
};

export default CGUPage;
